import React, { useEffect, useState } from "react";
import Input from "../FormComponents/Input";
import MaterialIcon from "./MaterialIcon";

const SearchQuery = ({ data, searchKey, onSearch, placeholder = "Search Users" }) => {
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const filteredData = data.filter((user) => user[searchKey].toLowerCase().includes(searchQuery.toLowerCase()));
    onSearch(filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, data, searchKey]);

  return (
    <div className="position_relative">
      <Input
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        containerStyle={{ position: "relative" }}
        inputBoxStyle={{ paddingLeft: "28px", height: "36px" }}
      />
      <MaterialIcon name="search" className="position_absolute font_size_large" style={{ top: "8px", left: "8px" }} />
    </div>
  );
};

export default SearchQuery;
